import { ComponentItem } from "designSystem/types/component-item-types";
import { action, makeObservable } from "mobx";
import { ChangeEvent, FunctionComponent, SyntheticEvent } from "react";
import CustomViewDialogStore from "../CustomViewDialogStore";
import { CanvasCommentsOrientationType, ICustomViewDataSheetOptions, IDataSheetViewDropDownOptions } from "./CustomViewOptions";
import CustomViewOptionsStore from "./CustomViewOptionsStore";

/**
 * This store contains information about composite view
 */
class DataSheetCustomViewOptionsStore <T extends ICustomViewDataSheetOptions = ICustomViewDataSheetOptions> extends CustomViewOptionsStore<T> {
	/** all the dropdown boxes selection options for the custom view */
	readonly dataSheetDropDownOptions: IDataSheetViewDropDownOptions;

	constructor(
		dataSheetDropDownOptions: IDataSheetViewDropDownOptions,
		component: FunctionComponent,
		customViewDialogStore: CustomViewDialogStore,
		options?: T,
	) {
		super(dataSheetDropDownOptions, component, customViewDialogStore, options);
		makeObservable(this);

		this.dataSheetDropDownOptions = dataSheetDropDownOptions;
	}

	/** indicates whether to show canvasWithPropertiesHeight option */
	get showCanvasWithPropertiesHeight(): boolean {
		const { canvasWithProperties } = this.options;
		return !!canvasWithProperties;
	}

	/** set the value for canvasWithProperties */
	@action setCanvasWithProperties = (event: SyntheticEvent, value: boolean): void => {
		this.options.canvasWithProperties = value;
	};

	/** set the value for canvas notes orientation */
	@action setCanvasNotesOrientation = (event: ChangeEvent<{}>, item: ComponentItem<CanvasCommentsOrientationType>): void => {
		this.options.canvasCommentsOrientation = item.value;
	};
}

export = DataSheetCustomViewOptionsStore;